module.exports = __webpack_public_path__ + "static/media/winter_super_pack_cat_FR.a0af95bc.png";